export default "<subcategories-filter [categories]=\"categories\" [subcategories]=\"subcategories\"></subcategories-filter>\n";